import { BoltIcon } from '@heroicons/react/20/solid';
import { useAppSelector } from 'app/hooks';
import { SystemOptionType } from 'data/types';
import usePtacUnitSwap from 'hooks/use-ptac-unit-swap';
import { ptacTerminalTwinMessage } from 'utils/ptac-operating-cost';
import PtacUnitComponentGroup from './ptac-unit-component-group';

type PtacSystemComponentsTableProps = Readonly<{
  option: SystemOptionType;
  onCustomSystemSaved?: (uniqueId: string) => void;
}>;

export default function PtacSystemComponentsTable({
  option,
  onCustomSystemSaved
}: PtacSystemComponentsTableProps) {
  const { alternativesFor, swap } = usePtacUnitSwap(
    option,
    onCustomSystemSaved
  );
  const isLoading = useAppSelector(
    (state) => state.ptacSelection.systems.status === 'loading'
  );
  const twinMessage = ptacTerminalTwinMessage(option);

  return (
    <div className='flex flex-col gap-4'>
      {twinMessage && (
        <div
          data-testid='ptac-terminal-twin-line'
          className='flex items-center gap-2 rounded-lg border border-green-200 bg-green-50 px-4 py-2 text-sm font-semibold text-green-800'
        >
          <BoltIcon className='h-4 w-4' />
          <span>{twinMessage}</span>
        </div>
      )}
      {option.configuration.condensers.map((condenser) => (
        <PtacUnitComponentGroup
          key={condenser.uniqueId}
          condenser={condenser}
          alternatives={alternativesFor(condenser.uniqueId)}
          isLoading={isLoading}
          onSwap={(productId) => swap(condenser.uniqueId, productId)}
        />
      ))}
    </div>
  );
}
